import { render, staticRenderFns } from "./Vue-Slider.vue?vue&type=template&id=108eb0dc&"
import script from "./Vue-Slider.vue?vue&type=script&lang=js&"
export * from "./Vue-Slider.vue?vue&type=script&lang=js&"
import style0 from "flickity/dist/flickity.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports